
namespace SorAraBul.PropertyManagement {
    export class TenantsColumns {
        static columnsKey = 'PropertyManagement.Tenants';
    }
}